import { jsx, Fragment } from "@builder.io/qwik/jsx-runtime";
import { component$ } from "@builder.io/qwik";
import { documentRenderer } from "./renderer.qwik.mjs";
const RichTextRenderer = component$(({ node, overwrites }) => {
  if (!node) {
    return null;
  }
  const renderer = documentRenderer(overwrites || {});
  return /* @__PURE__ */ jsx(Fragment, {
    children: renderer(node)
  });
});
export {
  RichTextRenderer
};
